import React from 'react';
import Link from 'gatsby-link';
import Image from 'gatsby-image';
import styles from './lets-chat.module.css';

const LetsChat = () => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>
        Ready to make an impact? <br />
        <a href="https://www.jkdesign.com/contact" className={styles.link}>
          Connect with us.
        </a>
      </h3>
    </div>
  );
};

export default LetsChat;



// WEBPACK FOOTER //
// ./src/components/footer/lets-chat/index.js